// extracted by mini-css-extract-plugin
export default {"wrapper":"PrivacyPolicy_wrapper__jCZ1h","textBlock":"PrivacyPolicy_textBlock__jOjmX"};